import { render, staticRenderFns } from "./TabbyInstallmentsModal.vue?vue&type=template&id=dc161c8e&"
import script from "./TabbyInstallmentsModal.vue?vue&type=script&lang=js&"
export * from "./TabbyInstallmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports